export default {
  title: 'Download {{app}}-appen',
  qr_code_desc: 'Scan denne QR-kode med din telefon for at downloade appen',
  cta: 'Download appen og log ind for at få {{amount}} i cashback!',
  download_from: 'Eller download fra:',
  direct_link: 'Direkte link:',
};
